import { render } from "./SalesChart.html?vue&type=template&id=4f287851"
import script from "./SalesChart.ts?vue&type=script&lang=ts"
export * from "./SalesChart.ts?vue&type=script&lang=ts"

import "./SalesChart.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script